<!-- 客户合并记录 -->
<template>
    <div v-loading="loading">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">客户名称</div>
                <el-select
                    size="small"
                    v-model="searchData.CusId"
                    filterable
                    clearable
                    remote
                    reserve-keyword
                    :remote-method="querySearch"
                    v-select-scroll-more="searchLoad"
                    class="search-item"
                >
                    <el-option v-for="optionItem in cusOptions" :key="optionItem.EntpCusId" :data-msg="optionItem" :label="optionItem.EntpCusName" :value="optionItem.EntpCusId">
                    </el-option>
                </el-select>
                <div class="search-name">操作时间</div>
                <el-date-picker
                    class="search-item"
                    style="width: 230px"
                    size="small"
                    v-model="datetime1"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    :picker-options="pickerOptions"
                    @change="onDate1TimeSelect"
                ></el-date-picker>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" style="margin-left: 10px" @click="handleSearch">查询</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border="" style="width: 100%; margin-bottom: 0px">
                <el-table-column show-overflow-tooltip width="190px" prop="ComCode" label="合并单号"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="120px" prop="EntpCusName" label="客户"></el-table-column>
                <el-table-column show-overflow-tooltip width="90px" prop="SumPayable" label="应收总额"></el-table-column>
                <el-table-column show-overflow-tooltip width="90px" prop="AgentAmount" label="代收总额"></el-table-column>
                <el-table-column show-overflow-tooltip width="90px" prop="AlreadyPaid" label="已收总额"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="ApplyName" label="合并人"></el-table-column>
                <el-table-column show-overflow-tooltip width="160px" prop="CreateTime" label="合并时间"></el-table-column>
                <el-table-column label="操作" :isCanSet="true" width="100">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button type="text" size="mini" @click="showDetailDialog(scope.row)">查看合并明细</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchDataLength"
            ></el-pagination>
        </div>

        <el-dialog :close-on-click-modal="false" append-to-body :title="'【' + entpCusName + '】' + comCode + ' 合并明细'" :visible.sync="dialogDetailVisible" width="900px">
            <div class="dialog-content" v-if="dialogDetailVisible">
                <CombineDetails
                    @closeDetails="closeDetailDialog"
                    :RecordId="recordId"
                    :EntpCusName="entpCusName"
                    @printPreview="printPreview"
                ></CombineDetails>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import CombineDetails from '@/components/business/customerManage/combineDetails';
export default {
    name: '',
    props: ['EntpCusId', 'EntpCusName'],
    components: { CombineDetails },
    data() {
        return {
            recordId:'',
            entpCusName: '',
            comCode: '',
            dialogDetailVisible: false,
            loading: false,
            tableData: [],
            searchDataLength: 0,
            searchData: {
                CusId: '',
                StartDate: '',
                EndDate: '',
                Page: 1,
                Limit: 10
            },
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            datetime1: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    mounted() {
        this.searchData.CusId = this.EntpCusId;
        if (this.EntpCusName) {
            this.cusOptions.push({
                EntpCusId: this.EntpCusId,
                EntpCusName: this.EntpCusName
            });
        }
        this.getRecords();
    },
    methods: {
        cancel() {
            this.$emit('closeRecords');
        },
        getRecords() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/RevenueManagement_H/GetCusCombineRecords',
                    hideLoading: true,
                    data: this.searchData
                })
                .then(res => {
                    if (!res.data) return;
                    this.tableData = res.data;
                    this.searchDataLength = res.count;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleSizeChange(val) {
            this.searchData.Page = 1;
            this.searchData.Limit = val;
            this.getRecords();
        },
        handleCurrentChange(val) {
            this.searchData.Page = val;
            this.getRecords();
        },
        async querySearch(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            let data = await this.$util.searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);

            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchLoad() {
            this.cusForm.Page += 1;
            this.querySearch();
        },
        handleSearch() {
            this.getRecords();
        },
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        printPreview(data){
            this.$emit('printPreview',data);
        },
        showDetailDialog(item) {
            this.dialogDetailVisible = true;
            this.entpCusName = item.EntpCusName;
            this.comCode = item.ComCode;
            this.recordId = item.Id;
        },
        closeDetailDialog(isEdit){
           if(isEdit){
               this.getRecords();
           }
           this.dialogDetailVisible = false;
        }
    }
};
</script>
<style lang="less" scoped>
.dialog-content {
    margin: 5px;
}
.btn-ctn {
    text-align: right;
}
.el-row {
    margin-bottom: 0px;
    &:last-child {
        margin-bottom: 0;
    }
}
</style>
